module.exports = __webpack_public_path__ + "frontend/assets/df803060910f2e04e3ffd98b2d0a6920.png";